import { useSelector } from "react-redux";

function GameZone() {
  const { games } = useSelector((state) => state.portfolio);

  return (
    <section className="mx-auto min-h-[calc(100vh-96px)] max-w-7xl px-5 py-4">
      <h1 className="text-4xl font-bold text-white">Game Zone</h1>
      <p className="mt-3 max-w-2xl text-slate-400">
        A dedicated page for games, experiments, so have fun!
      </p>

      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {games.map((game) => (
          <div
            key={game.title}
            className="rounded-3xl border border-white/10 bg-white/5 p-6"
          >
            <h2 className="text-xl font-semibold">{game.title}</h2>
            <p className="mt-2 text-slate-400">{game.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default GameZone;